<template>
  <div :class="['jump-header', passWaxWidth ? 'max-page-transform-width' : '']">
    <div class="header-left">
      <img src="~@/assets/image/qricon.png" alt="" />
      <span>花城FM</span>
    </div>
    <div class="open-app" @click="downloadApp">打开APP</div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "JumpHeader",
  setup() {
    const passWaxWidth = ref(false);
    let timer = null;

    const resizeHook = () => {
      window.addEventListener("resize", e => {
        if (timer) {
          return;
        }
        timer = setTimeout(() => {
          let innerWidth = window.innerWidth;
          if (innerWidth > 450) {
            passWaxWidth.value = true;
          }
          clearTimeout(timer);
        }, 300);
      });
    };

    const downloadApp = () => {
      const isAndroid = window.navigator.userAgent.indexOf("Android") >= 0 ? true : false;
      if (isAndroid) {
        window.location.href =
          "http://a.app.qq.com/o/simple.jsp?pkgname=com.gzbn.huachengfm&from=singlemessage";
      } else {
        window.location.href = "http://itunes.apple.com/cn/app/id1345966985?mt=8";
      }
    };

    onMounted(() => {
      let innerWidth = window.innerWidth;
      if (innerWidth > 450) {
        passWaxWidth.value = true;
      }
      resizeHook();
    });

    return {
      downloadApp,
      passWaxWidth
    };
  }
});
</script>

<style lang="scss" scoped>
.jump-header {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 45px;
  width: 100%;
  border-radius: 0 0 16px 16px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 0 13px;
  z-index: 999;
  // max-width: 500px;
  left: 50%;
  transform: translateX(-50%);

  .header-left {
    display: flex;
    align-items: center;

    & > img {
      width: 35px;
      height: 35px;
      border-radius: 4px;
    }

    & > span {
      font-size: 16px;
      color: #e73828;
      font-weight: 600;
      margin-left: 5px;
    }
  }

  .open-app {
    width: 80px;
    height: 25px;
    border: 1px solid #e73828;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e73828;
    font-size: 12px;
    letter-spacing: 1px;
    text-indent: 1px;
  }
}
</style>
